<div
  id="three-string-viewer-container-wrapper_{{uuid}}"
  class="three-string-viewer-container-wrapper"
  style="display: block; float: left; padding: 8px; width: 100%; height: 100%;">
  <div
    id="three-string-viewer-container_{{uuid}}"
    class="three-string-viewer-container"
    style="position: relative; display: block; float: left; width: 100%; height: 100%; background-color: lightgray;">

    <div
      [style.visibility]="loadError ? 'visible' : 'hidden'"
      class="string-line-viewer-load-error"
    >
      {{loadError}}
    </div>
    <!-- main plotting area for Three.js -->
    <canvas
      (click)="onClick($event)"
      (mousemove)="onMouseMoved($event)"
      (mouseout)="onMouseOut($event)"
      (keydown)="onKeyPress($event)"
      id="three-string-viewer-canvas_{{uuid}}"
      class="three-string-viewer-canvas"
      style="cursor: crosshair; position: absolute; left: 0; top: 0; z-index: 0;">

    </canvas>

    <!-- spikelines and any other overlays -->
    <canvas
      id="three-string-grid-canvas_{{uuid}}"
      class="three-string-grid-canvas"
      style="cursor: crosshair; position: absolute; left: 0; top: 0; z-index: 5; pointer-events: none">

    </canvas>

    <!-- distance (vertical) axis -->
    <canvas
      id="three-string-yaxis-canvas_{{uuid}}"
      class="night three-string-yaxis-canvas">

    </canvas>
    <img class="distance-expand" src="" alt="">

    <!-- time (horizontal) axis -->
    <canvas
      id="three-string-xaxis-canvas_{{uuid}}"
      class="night three-string-xaxis-canvas"
      style="z-index: 2;">
    </canvas>

    <!-- time (horizontal) axis -->
    <canvas
      id="three-string-timecursor-canvas_{{uuid}}"
      class="night three-string-timecursor-canvas"
      style="z-index: 3;">
    </canvas>

    <!-- command bar / title area overlaid on top -->
    <div id="three-string-command-bar_{{uuid}}"
         class="night three-string-command-bar"
         style="z-index: 100;">

      <div class="command-bar-title-wrapper">
        <span class="command-bar-title night"></span>
      </div>

      <!-- use <span> instead of <img> so we don't have to style as broken image image -->

      <span class="command-bar-icon-button selectionmanager-action" style="position: relative;">
            <span
              (click)="onManageSelection()"
              title="[CTRL-S] Selection group"
              class="command-bar-icon night selectionmanagerbutton"
              id="selectionmanagerbutton_{{uuid}}">

            </span>

            <div id="selectionmanagerbuttonpopup_{{uuid}}"
                 class="resizable-popup night selectionmanagerbuttonpopup"
                 style="top: 32px; right: 0;">

              <!-- selection manager content -->

            </div>

          </span>

      <span class="command-bar-icon-button graphsearch-action">
            <span
              (click)="onGraphSearch()"
              title="[CTRL-F] Search, [F3} Results"
              class="command-bar-icon night searchmanagerbutton"
              id="searchmanagerbutton_{{uuid}}">
            </span>

             <div id="searchmanagerbuttonpopup_{{uuid}}"
                  class="resizable-popup night searchmanagerbuttonpopup"
                  style="top: 32px; right: 0;">

              <!-- selection manager content -->

            </div>

          </span>

      <span class="command-bar-icon-button autofit-action">
            <span
              (click)="onAutoFitToggle()"
              title="Autofit the graph to the window"
              class="command-bar-icon night"
              id="autofitbutton">

            </span>
          </span>

      <span class="command-bar-icon-button nightmode-action">
            <span
              (click)="onNightModeToggle()"
              title="[CTRL-D] Switch between light and dark"
              class="command-bar-icon night"
              id="nightmodebutton">

            </span>
          </span>

      <span class="command-bar-icon-button spikemode-action">
            <span
              (click)="onSpikeModeToggle()"
              title="Enable or disable spike lines"
              class="command-bar-icon night"
              id="spikemodebutton">

            </span>
          </span>

      <span class="command-bar-icon-button gridmode-action">
            <span
              (click)="onGridModeToggle()"
              title="Enable or disable grid lines"
              class="command-bar-icon night"
              id="gridmodebutton">

            </span>
          </span>

      <span class="command-bar-icon-button simplehud-action">
            <span
              (click)="onHUDToggle()"
              title="Switch between simple and full HUD display modes"
              class="command-bar-icon night"
              id="simplehudbutton">

            </span>
          </span>

      <span class="command-bar-icon-button colormode-action">
            <span
              (click)="onColorModeToggle()"
              title="Switch between track and train coloring mode"
              class="command-bar-icon night"
              id="colormodebutton">

            </span>
          </span>

      <span class="command-bar-icon-button zoomout-action">
            <span
              (click)="onZoomOut()"
              title="Zoom out of graph"
              class="command-bar-icon night"
              id="zoomoutbutton">

            </span>
          </span>

      <span class="command-bar-icon-button zoomin-action">
            <span
              (click)="onZoomIn()"
              title="Zoom in to graph"
              class="command-bar-icon night"
              id="zoominbutton">

            </span>
          </span>

      <span class="command-bar-icon-button view-lock-action">
            <span
              (click)="onViewLock()"
              title="Lock / Unlock View"
              class="command-bar-icon night"
              [class.viewunlockedbutton]="!viewLocked"
              [class.viewlockedbutton]="viewLocked"
              id="viewlockbutton">
            </span>

          </span>

    </div>

  </div>

  <div style="clear: both; height: 1px;"></div>
</div>
